import React from 'react';
import {cn} from '@rocket-ui/tools';

export function LogoutGlyphIcon(): React.ReactElement {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M13 3.75L4.75 3.75L4.75 20.25L13 20.25" stroke="currentColor" strokeWidth="1.6" />
			<path d="M18.5 12L9.5625 12" stroke="currentColor" strokeWidth="1.6" />
			<path d="M21 12L16 17L16 7L21 12Z" fill="currentColor" />
		</svg>
	);
}

interface AuthorizedLayoutLogoutButtonProps {
	onLogout: () => void;
	className?: string;
}

export function AuthorizedLayoutLogoutButton({onLogout, className}: AuthorizedLayoutLogoutButtonProps): React.ReactElement {
	return (
		<button
			type="button"
			onClick={onLogout}
			className={cn('flex w-full items-center gap-3 text-base font-medium text-black transition-colors', className)}
		>
			<span className="inline-flex h-5 w-5 items-center justify-center text-black [&_svg]:h-5 [&_svg]:w-5">
				<LogoutGlyphIcon />
			</span>
			<span>Выйти</span>
		</button>
	);
}
